var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 16L14.0586 13.9609H10.9355L10.3145 16H8.35742L11.3809 7.39844H13.6016L16.6367 16H14.6797ZM13.625 12.4375L13.0039 10.4453C12.9648 10.3125 12.9121 10.1426 12.8457 9.93555C12.7832 9.72461 12.7188 9.51172 12.6523 9.29688C12.5898 9.07812 12.5391 8.88867 12.5 8.72852C12.4609 8.88867 12.4062 9.08789 12.3359 9.32617C12.2695 9.56055 12.2051 9.7832 12.1426 9.99414C12.0801 10.2051 12.0352 10.3555 12.0078 10.4453L11.3926 12.4375H13.625Z",
    fill: "#737575"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 16.5,
    height: 16.5,
    rx: 1.25,
    stroke: "#737575",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttChart);
export default __webpack_public_path__ + "static/media/gantt-chart.b3a457a2.svg";
export { ForwardRef as ReactComponent };